import React from 'react'
import './style.css'

interface SubtitleProps {
    text: string;
}

export const Subtitle: React.FC<SubtitleProps> = ({ text }) => {
    return (
        <h3 className='subtitle-dsg'>{text}</h3>
    );
}